module.exports = __webpack_public_path__ + "img/download_11.2f5c9b74.png";